import { Menu as MenuPrimitive } from '@base-ui/react/menu';

import { cn } from '@/lib/utils';

export type DropdownMenuLabelProps = MenuPrimitive.GroupLabel.Props & {
  inset?: boolean;
};

const DropdownMenuLabel = ({ className, inset, ...props }: DropdownMenuLabelProps) => {
  return (
    <MenuPrimitive.GroupLabel
      data-slot="dropdown-menu-label"
      data-inset={inset}
      className={cn(
        'px-1.5 py-1 text-[11px] font-medium tracking-wide text-gray-600 data-inset:pl-7',
        className,
      )}
      {...props}
    />
  );
};

export default DropdownMenuLabel;
